import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import HealthSavingsImg from '../../../assets/health-savings-and-spending.png';
import Button from '../../../components/Button';
import { HSSC_ROUTE } from '../../../routes/types';
import { formatPrice } from '../../../utils/utils';

export type HealthSavingsAndSpendingProps = React.PropsWithChildren<{
  accruedPensionData?: any;
  detailsRoute?: string;
}>;

const HealthSavingsAndSpending = ({
  accruedPensionData,
  detailsRoute = HSSC_ROUTE,
}: HealthSavingsAndSpendingProps) => {
  const navigate = useNavigate();

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
      <Row className={'m-0 p-0'}>
        <Col
          className={
            'm-0 p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>
            {'Health Savings & Spending'}
          </h4>
          <Button
            onClick={() => navigate(detailsRoute)}
            variant="primary-outline"
            rightIcon={light('chevron-right')}
            size="sm"
            href={`#${detailsRoute}`}
          >
            Details
          </Button>
        </Col>
      </Row>
      <Row className={'m-0 p-0'}>
        <Col className="m-0 p-0 border rounded-1 p-11">
          <Row className="px-6 px-lg-0 mb-5">
            {accruedPensionData ? (
              <>
                <Row className="px-0 mx-0 mb-3 pb-3 border-bottom">
                  <Col className="col-6 px-0 "></Col>
                  <Col className="px-0 text-end text-sm-12-lg-14 fw-light text-ligther-grey">
                    Account Balance
                  </Col>
                </Row>
                {accruedPensionData.map(
                  (
                    { title, subtitle, priceDescription, balance }: any,
                    index: number
                  ) => (
                    <Row
                      key={index}
                      className={`${
                        accruedPensionData.length !== index + 1
                          ? 'border-bottom'
                          : ''
                      } p-0 m-0`}
                    >
                      <Col className="col-6">
                        <Row className="mt-5 text-sub1 lh-xxs">
                          {title}
                        </Row>
                        <Row className="mb-3 text-caption text-dark-gray-50 fw-lighter lh-xxs">
                          {subtitle}
                        </Row>
                      </Col>
                      <Col className="px-0 text-end">
                        <Col className="mt-5 col-12 text-sub1 lh-xxs">
                          {`${formatPrice(Number(balance), 'en-US', {
                            currency: 'USD',
                            style: 'currency',
                            minimumFractionDigits: 0,
                          })}`}
                        </Col>
                        <Col className="mb-3 col-12 text-dark-gray-50 text-caption fw-light lh-xxs">
                          {priceDescription}
                        </Col>
                      </Col>
                    </Row>
                  )
                )}
              </>
            ) : (
              <Row className="m-0 py-11">
                <Col className="p-0 mt-7 mt-lg-0 d-flex flex-column align-items-center">
                  <img
                    src={HealthSavingsImg}
                    alt="health-savings-and-spending-img"
                  />
                  <div className="mt-9 d-flex justify-content-center justify-content-lg-start lh-xxs">
                    <h6 className="m-0 fw-normal">No Accounts</h6>
                  </div>
                  <div className="mt-1 d-flex justify-content-center justify-content-lg-start fw-light text-sub1 text-darker lh-xxs">
                    <span>You currently have no accounts on file.</span>
                  </div>
                </Col>
              </Row>
            )}
          </Row>
        </Col>
      </Row>
    </Row>
  );
};

export default HealthSavingsAndSpending;
